// errors
const ADD_ERROR = 'ADD_ERROR';
const RESET_ERRORS = 'RESET_ERRORS';

export default {
  ADD_ERROR,
  RESET_ERRORS,
};
